import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
    label: _ctx.label,
    push: _ctx.isActive,
    unelevated: _ctx.isActive,
    color: _ctx.isActive ? 'primary' : undefined
  }, _ctx.$attrs, { onClick: _ctx.onClick }), null, 16, ["label", "push", "unelevated", "color", "onClick"]))
}